export const CustomerCareColorScheme = {
  Light: 'light',
  Dark: 'dark',
  System: 'system'
} as const;

export type CustomerCareColorSchemeMode =
  (typeof CustomerCareColorScheme)[keyof typeof CustomerCareColorScheme];

const customerCareColorSchemeValues = new Set<string>(
  Object.values(CustomerCareColorScheme)
);

export function isCustomerCareColorScheme(
  value: unknown
): value is CustomerCareColorSchemeMode {
  return typeof value === 'string' && customerCareColorSchemeValues.has(value);
}
